import EditInput from '../../../../components/Input';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { getActivities } from 'src/redux/features/session/slice';
import { formatDate } from 'src/utils/helpers';
import { Typography, Button, Flex } from 'antd';
import { MinusCircleFilled } from '@ant-design/icons';
import SearchableDropdown from 'src/components/SearchableDropdown';
import en from 'src/messages/en.json';

export const GridTableBodyActivityRow = ({
  row,
  index,
  update,
  activity,
  activityIndex,
  onRemoveNewRow,
  onActivityRowTotalHeaderDurationChange,
  onActivityValueChange,
  disabled,
  max = 24,
  startDate,
}) => {
  const { data: activities } = useSelector(getActivities);
  const [projectActivities, setProjectActivities] = useState(row?.activities);

  const [value, setValue] = useState(
    activity.items.reduce((acc, col) => acc + col.duration, 0),
  );

  const [selectedActivity, setSelectedActivity] = useState(
    activity.activityName,
  );

  const onActivityChange = (value, index, activityIndex) => {
    setSelectedActivity(value);
    onActivityValueChange(value, index, activityIndex, row);
  };

  const onChange = (e, rowIndex, colIndex) => {
    const parseValue = Number(e.target.value);

    setValue(parseValue);
    onActivityRowTotalHeaderDurationChange(parseValue, rowIndex);
  };

  const canShowAddedActivityRow = () => {
    if (row.isExpanded && activity?.isNew) {
      return true;
    }

    if (!row.isExpanded && activity?.isNew) {
      return false;
    }

    if (row.isExpanded) {
      return true;
    }
  };

  const givenDate = formatDate(row.deactivatedDate);
  const start = formatDate(startDate);

  const isRestricted =
    givenDate && start && (givenDate <= start || givenDate === start);

  useEffect(() => {
    setValue(activity.items.reduce((acc, col) => acc + col.duration, 0));
  });

  if (!projectActivities || !projectActivities.length) {
    return null;
  }

  return (
    !isRestricted && (
      <Flex
        style={{
          display: canShowAddedActivityRow() ? 'flex' : 'none',
          borderBottom: '1px solid #F0F0F0',
        }}
        className="input-row"
        id={`${row.projectId}-${row.projectName.replaceAll(' ', '_')}`}
      >
        <Flex
          align="center"
          gap={'middle'}
          style={{ width: '33%', padding: '0 0.75rem 0 1.5rem' }}
          justify="space-between"
        >
          <Typography.Text strong style={{ whiteSpace: 'nowrap' }}>
            Activity
          </Typography.Text>

          <SearchableDropdown
            id={`activity-select-${index}-${activityIndex}`}
            options={
              projectActivities
                ?.filter((item) =>
                  row.category.toLowerCase() === en.Activities.Label.TimeOff
                    ? item.isDefault == false
                    : true,
                )
                .map((item) => ({
                  label: item.name,
                  value: `${item.name}-${item.id}`,
                  disabled: row.activityRows.some(
                    (activityItem) =>
                      activityItem.activityName?.toLowerCase() ===
                      item.name.toLowerCase(),
                  ),
                })) || []
            }
            onChange={(value) => {
              onActivityChange(value, index, activityIndex);
            }}
            disabled={disabled}
            placeholder={en.Timesheet.Placeholder.selectActivity}
            selected={
              activity?.activityName
                ? [activity.activityName]
                : projectActivities?.find((item) => item.id === 1)
                  ? [projectActivities.find((item) => item.id === 1)?.name]
                  : []
            }
            showSearch={false}
            style={{
              flex: 0.7,
              minWidth: 0,
            }}
            allowClear={false}
            showArrow={true}
            dropDownStyle={{ width: '9rem' }}
          />
          <Flex justify="flex-end" style={{ flex: 0.3 }}>
            <Flex justify="space-between" gap={'small'}>
              {row?.activityRows.length > 1 ? (
                <Button
                  type="link"
                  style={{
                    flex: 0.2,
                  }}
                  disabled={disabled}
                  onClick={() => onRemoveNewRow(index, activityIndex)}
                  icon={
                    <MinusCircleFilled
                      title="Remove Activity"
                      style={{ color: disabled ? undefined : '#FF0000' }}
                    />
                  }
                />
              ) : (
                ''
              )}
              <EditInput
                rowIndex={index}
                colIndex={-1}
                update={onChange}
                value={Number(value.toFixed(2))}
                isTotalInput={true}
                max={max}
                disabled={disabled}
              />
            </Flex>
          </Flex>
        </Flex>
        {activity?.items.map((activityCol, activityColIndex) => (
          <Flex
            key={`${row.projectId}-${activityCol.date}-${activityColIndex}`}
            align="center"
            justify="center"
            style={{ padding: '0.75rem', flex: '1 1 0', minWidth: 0 }}
          >
            <EditInput
              rowIndex={activityIndex}
              colIndex={activityColIndex}
              update={update}
              value={Number(activityCol.duration.toFixed(2))}
              disabled={disabled}
            />
          </Flex>
        ))}
      </Flex>
    )
  );
};
